module.exports = __webpack_public_path__ + "media/images/sp/visit_reservations_enpou/flow_04-5d0abb869ad48194d1117a81559c158f.jpg";